import { getEnv } from './utils/env';

const configForEnv = env => {
  switch (env) {
    case 'production':
      return {
        clientId: '0oa2ul8rlePlNldiQ5d7',
        issuer: 'https://login.guesty.com/oauth2/aus2jlqfuwAsNNp3D5d7',
      };
    case 'staging0':
      return {
        clientId: '0oa5uurgz2gTtijhN5d7',
        issuer: 'https://login-staging0.guesty.com/oauth2/aus5uux0nrEFk69cb5d7',
      };
    case 'staging1':
      return {
        clientId: '0oa3neqmudUZFIfZN5d7',
        issuer: 'https://login-staging1.guesty.com/oauth2/aus3neo7qztTuR1zV5d7',
      };
    case 'staging2':
      return {
        clientId: '0oa3ngzbghfTEbfCl5d7',
        issuer: 'https://login-staging2.guesty.com/oauth2/aus3nh12muTccaqOE5d7',
      };
    case 'staging3':
      return {
        clientId: '0oa3ombemqEw6cT3W5d7',
        issuer: 'https://login-staging3.guesty.com/oauth2/aus3ombig66YLfhRC5d7',
      };
    case 'staging4':
      return {
        clientId: '0oa3omohnx0Xwjrx05d7',
        issuer: 'https://login-staging4.guesty.com/oauth2/aus3omosg1lLlkHm65d7',
      };
    case 'staging5':
      return {
        clientId: '0oa29y255ckJUzcLd5d7',
        issuer: 'https://staging5-login.guesty.com/oauth2/aus12cy46gjfuW4S25d7',
      };
    case 'staging6':
      return {
        clientId: '0oa3os7v0eicQ5DoU5d7',
        issuer: 'https://login-staging6.guesty.com/oauth2/aus3osa2uwogb7Gec5d7',
      };
    case 'staging7':
      return {
        clientId: '0oa3m5ea29oisL4aN5d7',
        issuer: 'https://login-staging7.guesty.com/oauth2/aus3m5gnb3kLLJ7ju5d7',
      };
    case 'staging8':
      return {
        clientId: '0oa3oveun3zGzzfpi5d7',
        issuer: 'https://login-staging8.guesty.com/oauth2/aus3ovcl3qiAuFTtz5d7',
      };
    case 'staging9':
      return {
        clientId: '0oa3ovlaj3EUxZqiR5d7',
        issuer: 'https://login-staging9.guesty.com/oauth2/aus3ovjc23Cflnf2e5d7',
      };
    case 'staging10':
      return {
        clientId: '0oa3ovo8dp3S5wxkG5d7',
        issuer:
          'https://login-staging10.guesty.com/oauth2/aus3ovn0nt5AyybWn5d7',
      };
    case 'staging11':
      return {
        clientId: '0oa3ozd7zmmAfqcdo5d7',
        issuer:
          'https://login-staging11.guesty.com/oauth2/aus3ozf311RPHuiFB5d7',
      };
    case 'staging12':
      return {
        clientId: '0oa3p7dy1xC19sEFf5d7',
        issuer:
          'https://login-staging12.guesty.com/oauth2/aus3p7fqgqZi3Vc3j5d7',
      };
    case 'staging13':
      return {
        clientId: '0oa3p7juvrddC0bhi5d7',
        issuer:
          'https://login-staging13.guesty.com/oauth2/aus3p7iaksbjL4C215d7',
      };
    case 'staging14':
      return {
        clientId: '0oa51f7cu3NPfdHkT5d7',
        issuer:
          'https://login-staging14.guesty.com/oauth2/aus51f922aa0QcZbv5d7',
      };
    case 'staging15':
      return {
        clientId: '0oa5wyjcucA8FZPFg5d7',
        issuer:
          'https://login-staging15.guesty.com/oauth2/aus5wyckmmWGo44sy5d7',
      };
    case 'staging16':
      return {
        clientId: '0oa5uxaa3wjLeP9hP5d7',
        issuer:
          'https://login-staging16.guesty.com/oauth2/aus5ux7o96osjeeF15d7',
      };
    case 'staging17':
      return {
        clientId: '0oa5uushyjPhjSxEY5d7',
        issuer:
          'https://login-staging17.guesty.com/oauth2/aus5ut1ydkJ9Pp5RE5d7',
      };
    case 'staging18':
      return {
        clientId: '0oa7tmwr3eiGMJ8Xa5d7',
        issuer:
          'https://login-staging18.guesty.com/oauth2/aus7tmtvb3uAePNcB5d7',
      };
    case 'staging19':
      return {
        clientId: '0oa8afm0y9JAyUdK95d7',
        issuer:
          'https://login-staging19.guesty.com/oauth2/aus8aflbh52THqYg85d7',
      };
    case 'staging20':
      return {
        clientId: '0oa8b4wvupBVCdcxS5d7',
        issuer:
          'https://login-staging20.guesty.com/oauth2/aus8b4tj8wp4nPjnL5d7',
      };
    case 'sandbox':
      return {
        clientId: '0oaggw5it1YBHTmwW696',
        issuer: 'https://login-sandbox.guesty.com/oauth2/ausggvw8u7aMPqDpA696',
      };
    default:
      console.log('failed to find Okta config');
      return {};
  }
};

const OKTA_TESTING_DISABLEHTTPSCHECK = false;
const BASENAME = process.env.PUBLIC_URL || '';
const REDIRECT_URI = `${window.location.origin}/auth/login/callback`;
const USE_INTERACTION_CODE = false;

const config = configForEnv(getEnv());
export default {
  oidc: {
    ...config,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    useInteractionCode: USE_INTERACTION_CODE,
    ignoreLifetime: true,
  },
  app: {
    basename: BASENAME,
  },
};
